import { Text } from "atoms";
import React from "react";

export const FormHeading = ({ text }) => {
  return (
    <Text
      fontSize="2rem"
      color="primary.900"
      fontFamily="NeometricBold"
      borderBottom="1px solid"
      borderColor="neutral.100"
      pb="1.6rem"
    >
      {text}
    </Text>
  );
};
